import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import FAVORITE_POSTS_QUERY from '../graphql/favoritePosts';
import updateSubscribedList from '../utils/graphql/updateSubscribedList';
import { gql } from '../graphql/generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
const POST_FAVORITE_ADDED_SUBSCRIPTION = gql(`
  subscription postFavoriteAdded {
    post: postFavoriteAdded {
      ...PostSummaryFields
    }
  }
`);

const POST_FAVORITE_REMOVED_SUBSCRIPTION = gql(`
  subscription postFavoriteRemoved {
    post: postFavoriteRemoved {
      ...PostSummaryFields
    }
  }
`);

export default function useFavoritePosts() {
  const { data, subscribeToMore } = useQuery(FAVORITE_POSTS_QUERY);

  useEffect(() => {
    const unsubscribes = [
      POST_FAVORITE_ADDED_SUBSCRIPTION,
      POST_FAVORITE_REMOVED_SUBSCRIPTION,
    ].map((query) =>
      subscribeToMore({
        document: query,
        updateQuery: updateSubscribedList(
          'currentSession.user.favoritePosts',
          'post',
          query === POST_FAVORITE_ADDED_SUBSCRIPTION,
        ),
      }),
    );

    return () => {
      unsubscribes.forEach((unsubscribe) => {
        unsubscribe();
      });
    };
  }, [subscribeToMore]);

  return data?.currentSession?.user?.favoritePosts ?? [];
}
